//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SheetMetal.js";
import "../no/TaggedObject.js";
import "../no/NXColor.js";
import "../no/ViewDependentDisplayManager.js";
let d=[[],[[["objectType"],"GetFlatPatternObjectTypeDisplay",{R_:{displayData:''}},1,0],[["objectType","displayData"],"SetFlatPatternObjectTypeDisplay",{},2,0],[["calloutType"],"GetFlatPatternCalloutTypeDisplay",{R_:{displayData:''}},1,0],[["calloutType","displayData"],"SetFlatPatternCalloutTypeDisplay",{},2,0],[["count","displayData"],"GetFlatPatternAllObjectTypeDisplay",{},0,0],[["count","displayData"],"GetFlatPatternAllCalloutTypeDisplay",{},0,0]],[]];
SPLM.SheetMetal.FlatPatternSettings = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SheetMetal.FlatPatternSettings";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SheetMetal.FlatPatternSettings.FlatPatternObjectTypeDisplay = class{
    constructor(type,is_enabled,color,font,width){
        this.type=type;this.is_enabled=is_enabled;this.color=color;this.font=font;this.width=width;}
    get Type(){return this.type}
    set Type(val){this.type = val}
    get IsEnabled(){return this.is_enabled}
    set IsEnabled(val){this.is_enabled = val}
    get Color(){return this.color}
    set Color(val){this.color = val}
    get Font(){return this.font}
    set Font(val){this.font = val}
    get Width(){return this.width}
    set Width(val){this.width = val}
};

SPLM.SheetMetal.FlatPatternSettings.FlatPatternCalloutTypeDisplay = class{
    constructor(type,is_enabled,name){
        this.type=type;this.is_enabled=is_enabled;this.name=name;}
    get Type(){return this.type}
    set Type(val){this.type = val}
    get IsEnabled(){return this.is_enabled}
    set IsEnabled(val){this.is_enabled = val}
    get Name(){return this.name}
    set Name(val){this.name = val}
};

SPLM.SheetMetal.FlatPatternSettings.FlatPatternObjectType = Object.freeze({
    "BendCenterLine" : "BendCenterLine", "BendUpCenterLine" : "BendUpCenterLine", "BendDownCenterLine" : "BendDownCenterLine", "BendTangentLine" : "BendTangentLine", "OuterMoldLine" : "OuterMoldLine", "InnerMoldLine" : "InnerMoldLine", "ExteriorCurves" : "ExteriorCurves", "InteriorCurves" : "InteriorCurves", "InteriorCutoutCurves" : "InteriorCutoutCurves", "InteriorFeatureCurves" : "InteriorFeatureCurves", "LighteningHoleCenter" : "LighteningHoleCenter", "JoggleLine" : "JoggleLine", "AddedTopGeometry" : "AddedTopGeometry", "AddedBottomGeometry" : "AddedBottomGeometry", "ToolMarker" : "ToolMarker", "Hole" : "Hole", "Centermark" : "Centermark"});

export default SPLM;